import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchIdentityProviders } from 'common/services/api/IdentityProviders/IdentityProviders.thunks';
import { IdentityProvider } from 'common/types/Entities';

import type { RootState } from '../../app/store';

type IdentityProvidersState = {
    identityProviders: IdentityProvider[],
    loaded: boolean
};

const initialState: IdentityProvidersState = {
    identityProviders: [],
    loaded: false
};

const identityProvidersSlice = createSlice({
    name: 'identityProviders',
    initialState,

    reducers: (create) => ({
        setIdentityProviders: create.reducer((state, action: PayloadAction<IdentityProvider[]>) => {
            state.identityProviders = action.payload;
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchIdentityProviders.pending, state => {
            state.loaded = false;
            state.identityProviders = [];
        });
        builder.addCase(fetchIdentityProviders.fulfilled, (state, action: PayloadAction<IdentityProvider[]>) => {
            state.loaded = true;
            state.identityProviders = action.payload;
        });
        builder.addCase(fetchIdentityProviders.rejected, state => {
            state.loaded = false;
            state.identityProviders = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default identityProvidersSlice.reducer;
export const { setIdentityProviders } = identityProvidersSlice.actions;
export const selectIdentityProviders = (state: RootState) => state.identityProviders.identityProviders;
